module.exports = __webpack_public_path__ + "images/picto-sect-charts.png?fb981";